import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Copy } from "lucide-react";

function DuplicateGroup({ g, onMerged }) {
  const [keep, setKeep] = useState(g.plants[0].id);
  const [busy, setBusy] = useState(false);
  const merge = async () => {
    const others = g.plants.filter((p) => p.id !== keep);
    if (!window.confirm(`Zusammenführen? Behalten wird „${g.plants.find((p) => p.id === keep).name_de}“, ${others.map((p) => `„${p.name_de}“`).join(", ")} wird deaktiviert (nicht gelöscht) und leitet um.`)) return;
    setBusy(true);
    try {
      for (const o of others) await api.post("/admin/plants/merge", { source_id: o.id, target_id: keep });
      toast.success("Zusammengeführt");
      onMerged();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Zusammenführen fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="p-3 rounded-xl bg-white border flex flex-wrap items-center gap-3" style={{ borderColor: "var(--wp-border)" }} data-testid={`duplicate-group-${g.name_lat.replace(/\s+/g, "-")}`}>
      <span className="italic text-sm">{g.name_lat}</span>
      <span className="text-xs opacity-60">Behalten:</span>
      {g.plants.map((p) => (
        <label key={p.id} className="text-sm flex items-center gap-1 cursor-pointer">
          <input type="radio" name={`keep-${g.name_lat}`} checked={keep === p.id} onChange={() => setKeep(p.id)} /> {p.name_de}
        </label>
      ))}
      <button type="button" disabled={busy} onClick={merge} className="ml-auto text-xs px-3 py-1.5 rounded-full font-medium" style={{ backgroundColor: "#1C2E1F", color: "#F5EFE3" }} data-testid="duplicate-merge-btn">
        {busy ? "…" : "Zusammenführen"}
      </button>
    </div>
  );
}

export default function PlantDuplicatesPanel({ reloadKey, onChanged }) {
  const [groups, setGroups] = useState([]);
  const load = () => api.get("/admin/plants/duplicates").then((r) => setGroups(r.data || [])).catch(() => setGroups([]));
  useEffect(() => { load(); }, [reloadKey]);
  if (groups.length === 0) return null;
  return (
    <div className="plant-card p-4 mb-3 space-y-2" style={{ backgroundColor: "rgba(201,163,110,0.15)" }} data-testid="plant-duplicates-panel">
      <div className="text-sm font-medium flex items-center gap-2"><Copy className="w-4 h-4" /> Mögliche Dubletten (gleicher lateinischer Name)</div>
      {groups.map((g) => <DuplicateGroup key={g.name_lat} g={g} onMerged={() => { load(); onChanged(); }} />)}
    </div>
  );
}
